import React from "react";
import {
  Dialog,
  Slide,
  Stepper,
  Step,
  StepLabel,
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  CircularProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UploadUserDialog = ({ open, onClose }) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [events, setEvents] = React.useState([]); // placeholder for events
  const [selectedEvent, setSelectedEvent] = React.useState("");
  const [acknowledgeNoEvent, setAcknowledgeNoEvent] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);

  React.useEffect(() => {
    if (events.length === 0 && open) getAllEvents();
  }, [open]);

  const getAllEvents = async () => {
    const result = await request("events?unlisted=true");

    if (result.success) {
      setEvents(result.events);
    }
  };

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleClose = () => {
    setActiveStep(0);
    setSelectedEvent(null);
    setAcknowledgeNoEvent(false);
    onClose();
  };

  const handleFileChange = (e) => {
    if (e.target.files.length) {
      setSelectedFile(e.target.files[0]);
      handleNext();
    }
  };

  const handleEventChange = (e) => setSelectedEvent(e.target.value);
  const handleCheckboxChange = (e) => setAcknowledgeNoEvent(e.target.checked);

  const handleProcessUpload = async () => {
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      if (selectedEvent) {
        formData.append("eventId", selectedEvent);
      } 
      const token = localStorage.getItem(`${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Accesstoken: token,
        },
      };
      const url = `${process.env.REACT_APP_TNFT_SERVER}/users/uploadandassign`;
      const response = await axios.post(url, formData, config);
      const result = response.data;
      if (!result.success) {
        toast.error(result.error || "Unknown error");
      }
      setUploading(false);
      toast.success(result.message);
      // optionally handle result.rows or show a success message
    } catch (err) {
      console.error("Upload failed:", err?.response?.data?.error);
      toast.error(`Upload failed: ${err?.response?.data?.error}`);
    }
    setUploading(false);
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Upload Users
          </Typography>
        </Toolbar>
      </AppBar>

      <DialogContent>
        <Stepper activeStep={activeStep} orientation="vertical">
          <Step>
            <StepLabel>Select File</StepLabel>
          </Step>
          <Step>
            <StepLabel>Assign Event</StepLabel>
          </Step>
        </Stepper>
        {activeStep === 0 && (
          <div style={{ marginTop: 16 }}>
            <Button variant="contained" component="label">
              Choose CSV File
              <input
                type="file"
                accept=".csv"
                hidden
                onChange={handleFileChange}
              />
            </Button>
            <Typography style={{marginTop: 16}}>The file must have the following column headers: <span style={{fontWeight: 'bold'}}>email, firstName, lastName.</span> </Typography>
            <Typography><span style={{fontWeight: 'bold'}}>phone</span> is optional</Typography>
            <Typography>NOTE: The column headers are case sensitive!</Typography>
          </div>
        )}
        {activeStep === 1 && (
          <div
            style={{
              marginTop: 16,
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            <Typography style={{ marginBottom: 16 }}>
              Please either choose an event or check the checkbox
            </Typography>
            <Select
              value={selectedEvent}
              onChange={handleEventChange}
              displayEmpty
              fullWidth
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {events.map((evt) => (
                <MenuItem key={evt._id} value={evt._id}>
                  {evt.name}
                </MenuItem>
              ))}
            </Select>
            {selectedEvent ? null : (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={acknowledgeNoEvent}
                    onChange={handleCheckboxChange}
                  />
                }
                label="I acknowledge that uploaded users will not be assigned to any events"
              />
            )}
            {selectedEvent || acknowledgeNoEvent ? (
              <Button
                variant="contained"
                style={{ width: 200 }}
                onClick={handleProcessUpload}
                disabled={uploading}
              >
                {uploading ? <CircularProgress size={24} /> : "Upload File"}
              </Button>
            ) : null}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default UploadUserDialog;
